var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"healcode-widget"},[_c('healcode-widget',{attrs:{"data-type":"enrollments","data-widget-partner":"object","data-widget-id":"6d6696843b8","data-widget-version":"0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }